// Mock data for CrossFit Dashboard

export const todaysWorkout = {
  title: "Murph",
  type: "Hero WOD",
  description: "For Time: 1 Mile Run, 100 Pull-Ups, 200 Push-Ups, 300 Air Squats, 1 Mile Run",
  coach: "Scott Bramton",
  classTime: "2026-05-13T17:00:00",
  duration: "60 min",
  status: "booked",
  spotsLeft: 3,
  totalSpots: 12
};
export const movementsList = [
  { name: "Back Squat" },
  { name: "Front Squat" },
  { name: "Deadlift" },
  { name: "Bench Press" },
  { name: "Strict Press" },
  { name: "Push Press" },
  { name: "Push Jerk" },
  { name: "Clean" },
  { name: "Power Clean" },
  { name: "Squat Clean" },
  { name: "Snatch" },
  { name: "Power Snatch" },
  { name: "Clean & Jerk" },
  { name: "Thruster" },

  { name: "Pull-Up (Max Unbroken)" },
  { name: "Chest-to-Bar Pull-Up (Max Unbroken)" },
  { name: "Bar Muscle-Up (Max Unbroken)" },
  { name: "Ring Muscle-Up (Max Unbroken)" },
  { name: "Handstand Push-Up (Max Unbroken)" },
  { name: "Toes-to-Bar (Max Unbroken)" },
  { name: "Double Unders (Max Unbroken)" },

  { name: "500m Row" },
  { name: "2000m Row" },
  { name: "5k Run" },

  { name: "Murph" },

  { name: "Max Pull-Ups" },
  { name: "Max Push-Ups" },
  { name: "Max Air Squats" },
  { name: "Max Burpees" },
  { name: "Plank Hold" },
  { name: "Wall Sit" }
];

export const upcomingClasses = [
  {
    id: 1,
    date: "2026-05-14",
    time: "06:00 AM",
    coach: "Nataliya",
    type: "Strength & Conditioning",
    status: "booked",
    spotsLeft: 2
  },
  {
    id: 2,
    date: "2026-05-15",
    time: "17:00 PM",
    coach: "Scott Bramton",
    type: "CrossFit",
    status: "booked",
    spotsLeft: 5
  },
  {
    id: 3,
    date: "2026-05-16",
    time: "12:00 PM",
    coach: "Nataliya",
    type: "Olympic Lifting",
    status: "waitlist",
    position: 2
  }
];

export const attendanceData = {
  currentStreak: 12,
  bestStreak: 28,
  thisWeek: 4,
  thisMonth: 16,
  thisYear: 142,
  // Heatmap data for the last 12 months (simplified)
  heatmapData: generateHeatmapData()
};

function generateHeatmapData() {
  const data = [];
  const today = new Date();
  for (let i = 364; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const dayOfWeek = date.getDay();
    // More likely to train on weekdays
    const isWeekday = dayOfWeek > 0 && dayOfWeek < 6;
    const probability = isWeekday ? 0.7 : 0.3;
    const count = Math.random() < probability ? Math.floor(Math.random() * 2) + 1 : 0;
    data.push({
      date: date.toISOString().split('T')[0],
      count: count
    });
  }
  return data;
}

export const personalRecords = [
  {
    id: 1,
    name: "Back Squat",
    value: "142.5 kg",
    previous: "137.5 kg",
    date: "2026-05-10",
    trend: "up",
    improvement: "3.6%"
  },
  {
    id: 2,
    name: "Deadlift",
    value: "185 kg",
    previous: "180 kg",
    date: "2026-05-08",
    trend: "up",
    improvement: "2.8%"
  },
  {
    id: 3,
    name: "Fran",
    value: "4:32",
    previous: "5:12",
    date: "2026-05-05",
    trend: "up",
    improvement: "12.8%"
  },
  {
    id: 4,
    name: "Pull-Ups",
    value: "28 reps",
    previous: "25 reps",
    date: "2026-05-03",
    trend: "up",
    improvement: "12%"
  }
];

export const goals = [
  {
    id: 1,
    title: "200 Classes This Year",
    current: 142,
    target: 200,
    percentage: 71,
    category: "attendance",
    deadline: "2026-12-31"
  },
  {
    id: 2,
    title: "First Muscle-Up",
    current: 75,
    target: 100,
    percentage: 75,
    category: "skill",
    deadline: "2026-07-01",
    description: "Complete muscle-up progression"
  },
  {
    id: 3,
    title: "RX Fran",
    current: 80,
    target: 100,
    percentage: 80,
    category: "benchmark",
    deadline: "2026-06-30",
    description: "Complete Fran with prescribed weights"
  },
  {
    id: 4,
    title: "Body Weight Goal",
    current: 78,
    target: 75,
    percentage: 60,
    category: "nutrition",
    deadline: "2026-08-15",
    unit: "kg"
  }
];

export const aiCoachSummary = {
  weekSummary: "You trained 4 times this week—great consistency! Your endurance improved by 8%, but recovery may need attention.",
  insights: [
    {
      type: "strength",
      icon: "💪",
      message: "Your squat is progressing well. Consider adding accessory work."
    },
    {
      type: "recovery",
      icon: "😴",
      message: "You've trained hard. Schedule a rest day or active recovery."
    },
    {
      type: "nutrition",
      icon: "🥗",
      message: "Track your protein intake to support muscle recovery."
    }
  ],
  score: 8.2,
  trend: "up"
};

export const monthlyChallenge = {
  title: "May Mayhem 2026",
  description: "Complete 20 classes in May",
  progress: 16,
  target: 20,
  percentage: 80,
  rank: 12,
  totalParticipants: 87,
  daysLeft: 18,
  prize: "Free month membership"
};

export const trainingLoad = {
  weeklyLoad: "Balanced",
  level: 2, // 1: Light, 2: Balanced, 3: High
  recommendation: "You're training at a sustainable pace. Consider adding one more session if you feel recovered.",
  sessions: [
    { day: "Mon", load: 75, type: "Strength" },
    { day: "Tue", load: 0, type: "Rest" },
    { day: "Wed", load: 85, type: "MetCon" },
    { day: "Thu", load: 60, type: "Skills" },
    { day: "Fri", load: 90, type: "WOD" },
    { day: "Sat", load: 0, type: "Rest" },
    { day: "Sun", load: 40, type: "Active Recovery" }
  ]
};

export const achievements = {
  recentlyUnlocked: [
    {
      id: 1,
      name: "100 Classes",
      icon: "🎯",
      description: "Completed 100 classes",
      unlockedDate: "2026-04-15",
      rarity: "common"
    },
    {
      id: 2,
      name: "5AM Warrior",
      icon: "🌅",
      description: "Attended 10 early morning classes",
      unlockedDate: "2026-05-01",
      rarity: "rare"
    },
    {
      id: 3,
      name: "First Pull-Up",
      icon: "💪",
      description: "Achieved your first unassisted pull-up",
      unlockedDate: "2026-03-20",
      rarity: "uncommon"
    }
  ],
  locked: [
    {
      id: 4,
      name: "150 Classes",
      icon: "🔒",
      description: "Complete 150 classes",
      progress: 94.7,
      rarity: "common"
    },
    {
      id: 5,
      name: "Double Under Master",
      icon: "🔒",
      description: "Complete 100 unbroken double unders",
      progress: 45,
      rarity: "epic"
    }
  ]
};

export const leaderboard = [
  { rank: 1, name: "Emma Wilson", avatar: null, score: 18, trend: "same" },
  { rank: 2, name: "James Chen", avatar: null, score: 16, trend: "up" },
  { rank: 3, name: "Sofia Rodriguez", avatar: null, score: 16, trend: "down" },
  { rank: 4, name: "Marcus Taylor", avatar: null, score: 12, trend: "up" },
  { rank: 5, name: "Lisa Anderson", avatar: null, score: 10, trend: "same" },
  { rank: 12, name: "You", avatar: null, score: 10, trend: "up", isCurrentUser: true }
];

export const fitnessScore = {
  overall: 78,
  fitnessAge: 28,
  actualAge: 35,
  breakdown: {
    attendance: 85,
    consistency: 80,
    performance: 72,
    recovery: 75
  },
  explanation: "Your fitness age is 7 years younger than your actual age! This score is based on your training consistency, performance improvements, and recovery metrics."
};
